


























































import { defineComponent } from '@vue/composition-api';
import WizardButton from '@/components/clickables/WizardButton.global.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import InputCheckbox from '@/features/ui/inputs/InputCheckbox.global.vue';
import InputText from '@/features/ui/inputs/InputText.global.vue';

export default defineComponent<any, Record<string, unknown>, any, any>({
  components: { InputText, InputCheckbox, WizardButton },
  props: {
    searchTxt: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      modalOpen: false,
      searchValue: '',
      filteredHeatingSystemsData: [],
      searchInput: '',
      showCopyButton: false, // temporary hide the button so as to not make copy functionality available in prod and sales
    };
  },
  computed: {
    ...mapGetters(['activeControlModelName', 'filterHeatingSystemNames', 'canSaveRegisters']),
    ...mapState({
      heatingSystems: (state: any) => state.EditHeatingSystemRegistersModule.heatingSystems,
    }),
    isConfirmEnabled(): boolean {
      const anyChecked = this.filteredHeatingSystemsData.some(
        (heatingSystem: { checked: boolean }) => heatingSystem.checked,
      );
      return anyChecked && this.canSaveRegisters;
    },
  },
  watch: {
    activeControlModelName() {
      this.heatingSystemList(); // ✅ Call again when activeControlModelName changes
    },
    searchTxt(val) {
      this.searchInput = val;
      this.heatingSystemList();
    },
    searchInput() {
      this.heatingSystemList(); // 💡 Re-filter the list whenever user types
    },
  },
  mounted() {
    this.heatingSystemList(); // ✅ Call test on mount
  },
  methods: {
    ...mapActions({
      addToastMessages: 'ADD_TOAST_MESSAGES',
    }),
    openModal() {
      this.modalOpen = true;
      this.heatingSystemList();
    },
    selectAllHeatingSystems() {
      this.filteredHeatingSystemsData.forEach((heatingSystem: any) => {
        heatingSystem.checked = true;
      });
    },
    deselectAllHeatingSystems() {
      this.filteredHeatingSystemsData.forEach((heatingSystem: any) => {
        heatingSystem.checked = false;
      });
    },
    heatingSystemList(): void {
      const search = this.searchInput?.toLowerCase() || '';

      this.filteredHeatingSystemsData = this.filterHeatingSystemNames
        .filter((site: { id: string; name: string }) => site.name?.toLowerCase().includes(search))
        .map((site: { id: string; name: string }) => ({
          id: site.id,
          name: site.name,
          checked: false,
        }));
    },
    async copyRegisterValues() {
      const selectedHeatingSystems = this.filteredHeatingSystemsData
        .filter((hs: any) => hs.checked)
        .map((hs: any) => hs.id);

      this.$store.dispatch('copyHSRegisterValues', {
        apolloClient: this.$apollo,
        finalSave: true,
        selectedHeatingSystems,
      });
    },
  },
});
